import { render, staticRenderFns } from "./VideoAutoPlay.vue?vue&type=template&id=4ab5c603&scoped=true"
import script from "./VideoAutoPlay.vue?vue&type=script&lang=js"
export * from "./VideoAutoPlay.vue?vue&type=script&lang=js"
import style0 from "./VideoAutoPlay.vue?vue&type=style&index=0&id=4ab5c603&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab5c603",
  null
  
)

export default component.exports